/**
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = ['$stateParams'];

const EmployeeProfileNotesController = function($stateParams) {

  const vm = this;

  vm.employeeId = $stateParams.employeeId;

  return vm;

};

angular.module('public.security-manager.employee')
  .controller('EmployeeProfileNotesController', dependencies.concat(EmployeeProfileNotesController));
